import { ColorProps } from 'types';

// ==============================|| THEME 7 COLORS ||============================== //

const theme7: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#E3F2FD',
  primary200: '#90CAF9',
  primaryMain: '#2196F3',
  primaryDark: '#1E88E5',
  primary800: '#1565C0',

  // secondary (Amber)
  secondaryLight: '#FFF4E5',
  secondary200: '#FCD34D',
  secondaryMain: '#F59E0B',
  secondaryDark: '#D97706',
  secondary800: '#B45309',

  // success
  successLight: '#D1FAE5',
  success200: '#6EE7B7',
  successMain: '#10B981',
  successDark: '#059669',

  // error
  errorLight: '#FEE2E2',
  errorMain: '#EF4444',
  errorDark: '#DC2626',

  // orange
  orangeLight: '#FFF7ED',
  orangeMain: '#FB923C',
  orangeDark: '#EA580C',

  // warning
  warningLight: '#FEF3C7',
  warningMain: '#FBBF24',
  warningDark: '#D97706',

  // grey
  grey50: '#F8FAFC',
  grey100: '#EEF2F6',
  grey200: '#E3E8EF',
  grey300: '#CDD5DF',
  grey500: '#697586',
  grey600: '#4B5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#111936',
  darkBackground: '#1A223F',

  // dark levels
  darkLevel1: '#29314F',
  darkLevel2: '#212946',

  // text
  darkTextTitle: '#D7DCEC',
  darkTextPrimary: '#BDC8F0',
  darkTextSecondary: '#8492C4',

  // primary dark
  darkPrimaryLight: '#64B5F6',
  darkPrimaryMain: '#2196F3',
  darkPrimaryDark: '#1976D2',
  darkPrimary200: '#90CAF9',
  darkPrimary800: '#1565C0',

  // secondary dark (Amber)
  darkSecondaryLight: '#FCD34D',
  darkSecondaryMain: '#F59E0B',
  darkSecondaryDark: '#D97706',
  darkSecondary200: '#FBBF24',
  darkSecondary800: '#B45309'
};

export default theme7;